module.exports = __webpack_public_path__ + "static/media/locator.b8faabb5.png";